import type { ReactElement, ReactNode } from 'react';
import { FilterDefinitions } from './types';
import { useFilteringForm } from './useForm';
import { FormProvider } from 'react-hook-form';

export type FilterCustomViewProps = {
  children: ReactNode;
};

export const FilterCustomView = <T extends FilterDefinitions>({
  children,
}: FilterCustomViewProps): ReactElement => {
  const methods = useFilteringForm<T>();

  return (
    <FormProvider {...methods}>
      <form>{children}</form>
    </FormProvider>
  );
};
FilterCustomView.DisplayName = 'FilterCustomView';
